<table mat-table [dataSource]="this.ficha.data" class="w-full">

    <!-- avatar -->
    <ng-container matColumnDef="avatar">
        <th mat-header-cell *matHeaderCellDef>  </th>
        <td mat-cell *matCellDef="let element" class="w-1/12 text-center items">
            <div class="flex items-center justify-center">
                 <img [src]="element?.blobURL?? '/assets/images/img-placeholder.jpg'" alt="" class="w-8 h-8 object-fil flex-shrink-0 m-2 rounded-full shadow-sm bg-gray-100">
            </div>
        </td>
    </ng-container>

    <!-- Detalle Column -->
    <ng-container matColumnDef="detalleSolicitud">
      <th mat-header-cell *matHeaderCellDef> Bien Cultural </th>
      <td mat-cell *matCellDef="let element" class="w-4/12 px-2"> 
            <div class="py-4" >

                <div class="text-sm">
                    <mat-icon class="text-md">tag</mat-icon>
                    <span>Bien Cultural: </span>  <span class="font-bold">{{ element.bienCultural.bienCulturalUuid}}</span>
                </div>

                <div class="text-sm">
                    <mat-icon class="text-md">description</mat-icon>
                    <span>Nombre: </span>  <span class="font-bold">{{ element.bienCultural.titulo}}</span>
                </div>

                <div class="text-sm">
                    <mat-icon class="text-md">person</mat-icon>
                    <span>Titular: </span>  <span class="font-bold">{{ element.bienCultural.descripcionTitular}}</span>
                </div>

                <div class="text-sm" >
                    <mat-icon class="text-md">format_list_numbered</mat-icon>
                    <span>No. Registro: </span>  <span class="font-bold">{{ element.bienCultural.noRegistro}}</span>
                </div>

                <div class="text-sm">
                    <mat-icon class="text-md">today</mat-icon>
                    <span>Fecha de Registro: </span>  <span class="font-bold">{{element.bienCultural.fechaFichaRegistro | date}}</span>
                </div>
                <div class="text-sm">
                    <mat-icon class="text-md">person</mat-icon>
                    <span>Registrado por: </span>  <span class="font-bold">{{ element.bienCultural.fichaRegistroPor.nombreCompleto}}</span>
                </div>

                

            </div>

      </td>
    </ng-container>
    <!-- Tipo de Bien -->
    <ng-container matColumnDef="tipoBien">
      <th mat-header-cell *matHeaderCellDef class="px-2"> Tipo de Bien </th>
      <td mat-cell *matCellDef="let element" class="w-2/12 px-2 "> 
        <status-sticker [estado]="element.bienCultural.tipoBien?.descripcion" [color1]="element.bienCultural.tipoBien?.valor1" [color2]="element.bienCultural.tipoBien?.valor2"></status-sticker>
      </td>
    </ng-container>


  
    <!-- Seccion -->
    <ng-container matColumnDef="seccion">
      <th mat-header-cell *matHeaderCellDef class="px-2"> Sección </th>
      <td mat-cell *matCellDef="let element" class="w-2/12 px-2 "> 
        <status-sticker [estado]="element.bienCultural.seccion?.descripcion" [color1]="element.bienCultural.seccion?.valor1" [color2]="element.bienCultural.seccion?.valor2"></status-sticker>
      </td>
    </ng-container>
  
    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let element"  class="w-1/12 px-2"> 
            <button mat-icon-button (click)="openDetails(element.bienCultural.bienCulturalUuid)">
                <mat-icon>open_in_new</mat-icon>
            </button>
      </td>
    </ng-container>
  
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  
  <mat-paginator [length]="ficha.total" [pageSize]="pageSizes" [hidePageSize]="true"></mat-paginator>